module.exports = "<div class=card style=min-height:200px ng-if=!$ctrl.loadComplete> <spn-loading></spn-loading> </div> <div style=min-height:200px ng-if=$ctrl.loadComplete> <div ui-view></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/logistic/logistic.template.html
// module id = 18
// module chunks = 0 9